import { useT } from "../i18n";
import { href } from "../content/shared";
import { PageHero, Reveal, SectionHead, ArrowLink } from "../components/kit";
import { DownloadBand } from "./Home";
import { CheckList } from "../components/Demo";
import { StepPhone } from "../components/StepPhone";
import D from "../content/demos";

export default function HowItWorks() {
  const { lang, t } = useT();
  const h = { ...t.how, steps: [...t.how.steps, { ...D[lang].howCall }] };
  const SCENES = ["register", "plate", "search", "send", "receive", "call"];
  return (
    <>
      <PageHero eyebrow={h.eyebrow} lines={h.h1} lead={h.lead} testid="how-hero" />
      <section className="container-x pb-10" data-testid="how-steps">
        <ol className="border-t border-border">
          {h.steps.map((s, i) => (
            <li key={i} className="grid items-center gap-10 border-b border-border py-14 md:grid-cols-2 md:gap-16 md:py-20" data-testid={`how-step-${i + 1}`}>
              <Reveal className="max-w-xl">
                <p className="font-display text-5xl font-semibold text-primary md:text-7xl">{String(i + 1).padStart(2, "0")}</p>
                <h2 className="mt-6 text-2xl md:text-3xl">{s.title}</h2>
                <p className="mt-4 text-muted-foreground">{s.text}</p>
                {s.points && <CheckList items={s.points} className="mt-5" />}
              </Reveal>
              <div className={i % 2 ? "md:order-first" : ""}>
                <StepPhone scenario={SCENES[i]} chat={s.chat || t.how.steps[4]?.chat || []} testid={`how-phone-${i + 1}`} />
              </div>
            </li>
          ))}
        </ol>
      </section>
      <section className="bg-surface-2" data-testid="how-edge-cases">
        <div className="container-x section">
          <SectionHead eyebrow={h.edgeEyebrow} title={h.edgeH2} lead={h.edgeLead} />
          <div className="mt-12 grid gap-px overflow-hidden rounded-2xl border border-border bg-border md:grid-cols-2">
            {h.edges.map((e, i) => (
              <Reveal key={i} className="bg-surface p-7 md:p-9">
                <h3 className="text-xl">{e.t}</h3>
                <p className="mt-3 text-muted-foreground">{e.d}</p>
              </Reveal>
            ))}
          </div>
          <ArrowLink to={href(lang, "safety")} className="mt-8" testid="how-safety-link">{h.safetyLink}</ArrowLink>
        </div>
      </section>
      <div className="pt-20"><DownloadBand /></div>
    </>
  );
}
